import { createRequestDataSource } from "@ngneat/elf-requests";
import { selectAllEntities } from "@ngneat/elf-entities";
import { unipileInvitationsStore } from "@store/unipile/unipileInvitations/unipileInvitations.store";

export const getUnipileInvitationsDataSource = createRequestDataSource({
  store: unipileInvitationsStore,
  data$: () => unipileInvitationsStore.pipe(selectAllEntities()),
  requestKey: "getUnipileInvitations",
  dataKey: "unipileInvitations",
});